import { CommissionModel } from 'api-hooks/commission';
import { SaleDepartmentEnum } from 'common/constants/enum';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

export const commissionDetailFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    type: Yup.string().required().default('fixed'),
    commissionable: Yup.string().default(''),
    leadCommission: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .required()
      .default(0)
      .when('type', {
        is: 'percentage',
        then: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .required()
          .default(0)
          .max(100),
      }),
    operatorSalesCommission: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .required()
      .default(0)
      .when('type', {
        is: 'percentage',
        then: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .required()
          .default(0)
          .max(100),
      }),
    // additional information
    customId: Yup.string().default(''),
  });

export const commissionFormSchema = () =>
  Yup.object({
    department: Yup.string().required().default(SaleDepartmentEnum.Flight),
    appliedOn: Yup.date().required().default(new Date()),
    hasBaseCommission: Yup.boolean().default(false),
    type: Yup.string().nullable().default(null),
    leadCommission: Yup.number()
      .nullable()
      .default(null)
      .when('type', {
        is: 'percentage',
        then: Yup.number().nullable().default(null).max(100),
      }),
    operatorSalesCommission: Yup.number()
      .nullable()
      .default(null)
      .when('type', {
        is: 'percentage',
        then: Yup.number().nullable().default(null).max(100),
      }),
    commissionMasterAdditionals: Yup.array(
      commissionDetailFormSchema(),
    ).default([]),
  });

export type CommissionFormType = Yup.InferType<
  ReturnType<typeof commissionFormSchema>
> & { commission?: CommissionModel };

export type CommissionDetailFormType = Yup.InferType<
  ReturnType<typeof commissionDetailFormSchema>
>;

export type CommissionMethodType = ReturnType<
  typeof useForm<CommissionFormType>
>;
